// lightbox class code
import RuLightbox from "./../components/ru_lightboxbasic.js";

/////////////////////////
// Calling ruLightbox class

// CONTACT
const isContact = document.querySelector(".page-kontakt");
console.log("isContact");
if (isContact) {
  // CONTACT newsletter lightbox
  const contactDialogNews = new RuLightbox(
    "#newsletter_modal__btn-contact",
    "#newsletter_modal"
  );
  // CONTACT maps lightbox
  const contactDialogMap = new RuLightbox(
    ".contact_map_link",
    ".rulightbox_contact_02"
  );
}
